<!-- Old Layout -->
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <!-- <h2 class="title-heading">{{settings[selected].title}}</h2> -->
    <h2 class="title-heading">{{ pageTitle }}</h2>
    <div class="item nowrap">
      <span class="btn-container top-button-container">
        <ng-template [ngIf]="selected == 'active' && routepage === 'activedeliveries'">
          <button 
            [disabled]="
              (loggedInPartner?.partnerPaymentMethod && loggedInPartner?.partnerPaymentStatus === null) ||
              ['inactive', 'blocked'].includes(loggedInPartner?.partnerPaymentStatus)
            " 
            class="btn btn-white vertical align-items-center" 
            routerLink="/consegne/nuovo" 
            *ngIf="groups.includes('admin') || groups.includes('partner') || groups.includes('operation')"
          >
          Aggiungi<i class="ml-10 fas fa-plus"></i>
          </button>
        </ng-template>

        <button class="btn btn-white vertical align-items-center" (click)="export()" *ngIf="routepage === 'activedeliveries'">
          Esporta<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="import()" *ngIf="(groups.includes('admin') || groups.includes('operation')) && routepage === 'activedeliveries'">
          <input type="file" name="file" class="custom-file-input" id="importcsv" required (change)="handleImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>
        
        <button class="btn btn-white vertical align-items-center" (click)="importDeliveriesPartner()" *ngIf="groups.includes('partner') && routepage === 'activedeliveries'">
          <input type="file" name="file" class="custom-file-input" id="importcsvpartner" required (change)="handlePartnerImport($event)" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" hidden>
          Importare<i class="ml-10 fas fa-file-excel"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="plotDeliveriesOnMap()" *ngIf="selected == 'active' && routepage === 'activedeliveries'" [class.disabled-btn]="optimized">
          Map<i class="ml-10 fas fa-map-marker-alt"></i>
        </button>

        <button class="btn btn-white vertical align-items-center" (click)="resetMap()" *ngIf="selected == 'active' && routepage === 'activedeliveries'" [class.disabled-btn]="!optimized">
          Reset<i class="ml-10 fas fa-undo"></i>
        </button>

        <button class="btn vertical align-items-center full-width-btn" (click)="downloadCsvFormat()" *ngIf="(groups.includes('admin') || groups.includes('operation')) && routepage === 'activedeliveries'">
          Scarica il formato CSV
        </button>

        <button class="btn vertical align-items-center full-width-btn" (click)="downloadCsvFormatPartner()" *ngIf="groups.includes('partner') && routepage === 'activedeliveries'">
          Scarica il formato CSV
        </button>

        <ng-template [ngIf]="selected == 'active' && routepage === 'activedeliveries'">
          <button class="btn vertical align-items-center full-width-btn" routerLink="/nuovo-consegne/attiva/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive' && routepage === 'activedeliveries'">
          <button class="btn vertical align-items-center full-width-btn" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a CONSEGNE
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'active' && routepage === 'notdelivered'">
          <button class="btn vertical align-items-center full-width-btn" routerLink="/nuovo-consegne/archivio/storico">
            Storico<i class="ml-10 far fa-folder"></i>
          </button>
        </ng-template>

        <ng-template [ngIf]="selected == 'inactive' && routepage === 'notdelivered'">
          <button class="btn vertical align-items-center full-width-btn" [routerLink]="['../']" [queryParams]="{navigation: 'back'}">
            <i class="ml-10 fas fa-arrow-left has-margin-right"></i>Ritorna a CONSEGNE
          </button>
        </ng-template>
      </span>
    </div>

    <div class="filter-accordion">
      <div class="filter-accordion-header" (click)="toggleAccordion()">
        <h3>DELIVERIES MAP</h3>
        <i class="fas" [ngClass]="{ 'fa-chevron-down': !isDeliveryMapAccordionOpen, 'fa-chevron-up': isDeliveryMapAccordionOpen }"></i>
      </div>
      <div class="filter-accordion-content" [ngClass]="{ 'open': isDeliveryMapAccordionOpen }">
        <div class="filter-container">
          <div class="card-container map" id="deliveriesMap"></div>
        </div>
      </div>
    </div>
    <div class="item nowrap" style="margin-top: 15px;" *ngIf="(loggedInExpert && groups.includes('expert') && loggedInExpert?.isTeamLeader)">

      <button class="btn hvr-grow has-margin-right" style="border-radius: 6px; margin-right: 5px;">
        Mostra
      </button>

      <select id="valet-delivery-options" class="" style="border-radius: 6px;" [(ngModel)]="teamLeaderDeliveryOptions" (ngModelChange)="handleTeamLeaderDeliveryOptions()">
        <option value="all-deliveries">Tutti</option>
        <option value="own-deliveries">Le mie consegne</option>
        <option value="other-valet-deliveries">Consegne dei Valet</option>
      </select>
    </div>
  </div>
</section>

<!-- <section class="wrapper map-content-padding" *ngIf="selected == 'active' && routepage === 'activedeliveries'">
  <div class="filter-accordion">
    <div class="filter-accordion-header" (click)="toggleAccordion()">
      <h3>DELIVERIES MAP</h3>
      <i class="fas" [ngClass]="{ 'fa-chevron-down': !isDeliveryMapAccordionOpen, 'fa-chevron-up': isDeliveryMapAccordionOpen }"></i>
    </div>
    <div class="filter-accordion-content" [ngClass]="{ 'open': isDeliveryMapAccordionOpen }">
      <div class="filter-container">
        <div class="card-container map" id="deliveriesMap"></div>
      </div>
    </div>
  </div>
</section> -->

<section class="main-content wrapper content-padding scroll-delivery">
  <!-- legenda -->
  <div class="col-100 left">
    <h3>{{settings[selected].subtitle}}</h3>
    <div class="flex-container leggenda">
      <div class="item" *ngFor="let dSActive of deliveryStatusAux[selected]">
        <span class="status {{deliveryStatusAux.css(dSActive)}}"></span>
        <span 
          class="badge {{deliveryStatusAux.css(dSActive)}}"
          [ngClass]="selectedStatus === dSActive ? deliveryStatusAux.css(dSActive) + ' active-badge' : 'badge-color'"
          (click)="onStatusClick(dSActive)">
          {{ deliveryStatusAux.ln('it', dSActive) }}
        </span>
      </div>
    </div>
  </div>
  <!--
  <div class="col-100 left" *ngIf="routepage === 'notdelivered'">
    <h3>{{settings[selected].subtitle}}</h3>
    <div class="flex-container leggenda">
      <div class="item" *ngIf="selected === 'active'">
        <span class="status green"></span>
        Consegnata
      </div>
      <div class="item" *ngIf="selected === 'inactive'">
        <span class="grey status"></span>
        Annullata
      </div>
    </div>
  </div>
  -->
  <br class="clear">

  <!--Custom built table-->
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegneAdmin">
    <!-- Filters and header -->
    <form class="table-row-container row first-row filter" [formGroup]="_deliveryFilterForm" (ngSubmit)="filter()"
      *ngIf="_deliveryFilterForm">

      <!-- 
      <select id="valet-delivery-options" class="" style="border-radius: 6px;" formControlName="TeamLeader.deliveryoptions">
        <option value="all-deliveries">Tutti</option>
        <option value="own-deliveries">Le mie consegne</option>
        <option value="other-valet-deliveries">Consegne dei Valet</option>
      </select> 
      -->

      <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <h4 class="title">&nbsp;</h4>
        <span class="data">
            &nbsp;
        </span>
      </div>

      <div class="item center data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <h4 class="title">STATO</h4>
        <span class="data">
          <select formControlName="Delivery.status" >
            <option value="">Tutti</option>
            <option *ngFor="let dSActive of deliveryStatusAux[selected]" [value]="dSActive">
              {{deliveryStatusAux.ln('it', dSActive)}}
            </option>
          </select>
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <h4 class="title" (click)="navigateOrder('Delivery.ddtNumber')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.ddtNumber')"></i>
          VENDITA
        </h4>
        <span class="data">
          <input type="text" formControlName="Delivery.ddtNumber" min="1000" max="10000" >
        </span>
      </div>

      <div class="item center data-col-5">
        <h4 class="title">PLATFORM</h4>
        <span class="data">
          <select formControlName="Sale.platform">
            <option value="">Tutti</option>
            <option value="shopifysale">Deluxy Vendita</option>
            <option value="cakesales">Cakes Vendita</option>
            <option value="flowerssales">Flowers Vendita</option>
            <option value="deluxyexperiencesales">Deluxy Experience Vendita</option>
            <option value="deluxydotcomsales">Deluxy Dot Com Vendita</option>
            <!-- <option value="businesssales">Business Vendita</option>
            <option value="martesana">Martesana Milano</option>
            <option value="emailed">Email Vendita</option> -->
          </select>
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <h4 class="title" (click)="navigateOrder('Delivery.id')">
          <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.id')"></i>
          ID
        </h4>
        <span class="data">
          <input type="number" formControlName="Delivery.id" min="1000" max="10000" >
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <h4 class="title" (click)="navigateOrder('Delivery.parentDeliveryId')">
          <i class="sort-icon fas " [ngClass]="orderIcon('Delivery.parentDeliveryId')"></i>
          ORIGINAL CONSEGNA
        </h4>
        <span class="data">
          <input type="number" formControlName="Delivery.parentDeliveryId" min="1000" max="10000" >
        </span>
      </div>



      <div class="item data-col-{{getSpacing('deliveryDate')}}">
        <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
          DATA
        </h4>
        <span class="data">
          <div class="date">Da: </div>
          <input class="date" type="date" formControlName="Delivery.deliveryDate_from">
        </span>
        <span class="data">
          <div class="date">A: </div>
          <input class="date" type="date" formControlName="Delivery.deliveryDate_to">
        </span>
      </div>



      <div  class="item center data-col-{{getSpacing('time')}}">
        <h4 class="title" (click)="navigateOrder(['Delivery.fromTime'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime'])"></i>
          ORARIO
        </h4>
        <span class="data">
          <div class="date">Da: </div>
          <input class="date" type="time" formControlName="Delivery.fromTime">
        </span>
        <span class="data">
          <div class="date">A: </div>
          <input class="date" type="time" formControlName="Delivery.toTime">
        </span>
      </div>



      <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert', 'operation', 'teamleader'])">
        <h4 class="title" (click)="navigateOrder('Partner.businessName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
          PARTNER
        </h4>
        <span class="data">
          <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
        </span>
      </div>



      <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <h4 class="title" (click)="navigateOrder(['UserExpert.surname'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname'])"></i>
          VALET
        </h4>
        <span class="data"> <!-- DG  -->
        <input type="text" formControlName="UserExpert.surname" >   <!--
          <select id="selezioneExpert" type="text" formControlName="UserExpert.id" >
            <option value="">---</option>
            <option *ngFor="let expert of experts" [value]="expert.id">
              {{expert.user.surname}} {{expert.user.name}}</option>
          </select>        -->
        </span>
      </div>

      <!--
      <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted(['admin', 'operation', 'partner']) ">
        <h4 class="title" (click)="navigateOrder(['User.surname'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['User.surname'])"></i>
          CUSTOMER
        </h4>
        <span class="data">
          <input type="text" formControlName="User.surname" >
        </span>
      </div>
      -->

      <div class="item data-col-{{getSpacing('address')}}">
        <h4 class="title" (click)="navigateOrder(['Delivery.address'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.address'])"></i>
          INDIRIZZO
        </h4>

        <span class="data">
          <input type="text" formControlName="Delivery.address" >
        </span>
      </div>

      <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
        <h4 class="title" (click)="navigateOrder(['Delivery.pickUpAddress'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpAddress'])"></i>
          INDIRIZZO DI RITIRO</h4>
        <span class="data">
          <!-- <input type="text" formControlName="Partner.address"> -->
          <input type="text" formControlName="Delivery.pickUpAddress">
        </span>
      </div>

      <!--
      <div class="item data-col-{{getSpacing('address')}} pickUpTime">
        <h4 class="title" (click)="navigateOrder(['Delivery.pickUpTime', 'Delivery.pickUpTime'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpTime', 'Delivery.pickUpTime'])"></i>
          ORA RITIRO
        </h4>
        <span class="data">
          <div class="date"></div>
          <input class="date" type="time" formControlName="Delivery.pickUpTime">
        </span>
      </div>
      -->

      <div  class="item center data-col-{{getSpacing('time')}}">
        <h4 class="title" (click)="navigateOrder(['Delivery.pickUpFromTime'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.pickUpFromTime'])"></i>
          ORA RITIRO
        </h4>
        <span class="data">
          <div class="date">Da: </div>
          <input class="date" type="time" formControlName="Delivery.pickUpFromTime">
        </span>
        <span class="data">
          <div class="date">A: </div>
          <input class="date" type="time" formControlName="Delivery.pickUpToTime">
        </span>
      </div>

      <!-- <div class="item data-col-{{getSpacing('address')}} pickUpTime" *ngIf="selected == 'inactive'">
        <h4 class="title" (click)="navigateOrder(['Delivery.approvedTimings', 'Delivery.approvedTimings'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.approvedTimings', 'Delivery.approvedTimings'])"></i>
          APPROVED TIMINGS
        </h4>
        <span class="data">
          <div class="date"></div>
          <input class="date" type="time" formControlName="Delivery.approvedTimings">
        </span>
      </div> -->

      <div class="item center data-col-5">
        <h4 class="title">TIPO SERVIZIO</h4>
        <span class="data">
          <select formControlName="Delivery.serviceType">
            <!-- <option [selected]="true" [disabled]="true">Service Type</option> -->
            <option value="">Tutti</option>
            <option value="sales">Servizi Vendita</option>
            <option value="hourlyrate">Servizi a Ora</option>
            <option value="fixedprice">Servizi a Prezzo Fisso</option>
            <option value="corporate">Servizio Aziendale</option>
            <option value="warehouseservice">Servizio Magazzino</option>
          </select>
        </span>
      </div>

      <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <h4 class="title">DA FATTURARE</h4>
        <span class="data">
          <select formControlName="Delivery.billable" style="width: 120px;">
            <option value="">Tutti</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </span>
      </div>

      <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <h4 class="title">DA PAGARE</h4>
        <span class="data">
          <select formControlName="Delivery.payable" style="width: 120px;">
            <option value="">Tutti</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </span>
      </div>

      <!--
      <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <h4 class="title">REGOLA DI CONSEGNA TOTALE</h4>
        <span class="data">
          <select formControlName="Delivery.withTotalDeliveryRule" style="width: 120px;">
            <option value="">Tutti</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </span>
      </div>

      <div class="item center data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <h4 class="title">REGOLA DI CONSEGNA GIORNALIERA</h4>
        <span class="data">
          <select formControlName="Delivery.withDailyDeliveryRule" style="width: 120px;">
            <option value="">Tutti</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </span>
      </div>
      -->

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); fnReset();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>


    <div class="table-row-container row" *ngFor="let delivery of deliveries">

      <div class="item data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <span class="data-row-left">

          <!-- <h4 class="title">&nbsp;</h4> -->
          <!-- No Longer Needed
          <br>
          <img src="favicon.ico" width="20" height="20" *ngIf="delivery.deluxyDelivery">
          <br>
          -->
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader'])">
            <span class="green-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByPartner != null">
              <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            </span>
            <span class="blue-text" *ngIf="delivery.readDelivery && delivery.deliveryReadByExpert != null">
              <i class="fa fa-chevron-down" aria-hidden="true"></i>&nbsp;
            </span>

          </a>
        </span>
      </div>
      <!--
      <div class="item data-col-{{getSpacing('id')}}" >


        <span class="data-row-left">
          ciaoi
          <img src="favicon.ico" width="20" height="20" *ngIf="delivery.deluxyDelivery">

          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" >
            <span class="green-text" *ngIf="delivery.readDelivery">
              <i class="fa fa-check" aria-hidden="true"></i>&nbsp;
            </span>

          </a>

          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
            <span
              [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
          </a>

        </span>
      </div>-->
      <div class="item left-space data-col-{{selected == 'active' ? getSpacing('status') : getSpacing('historyStatus')}}">
        <span class="data-row-left">
          <h4 class="title">STATO :</h4>
          <span class="status-service-image">
            <img class="service-img" [src]="showServiceDetails(delivery)?.service?.image" width="50" height="50" *ngIf="showServiceDetails(delivery)?.service?.image">
            <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" [ngClass]="delivery.status == 'delivering' ? 'blink' : ''">
              <span class="dataGesture">
                <span [matTooltip]="deliveryStatusAux.ln('it', delivery.status)" class="status {{deliveryStatusAux.css(delivery.status)}}"></span>
                <!-- {{deliveryStatusAux.ln('it', delivery.status)}} -->
              </span>
            </a>
          </span>
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <span class="data-row-left">
          <h4 class="title table-title">VENDITA:</h4>
          <!-- <span class="status-service-image">
            <img class="service-img" src="assets/img/businessdeluxylogo.png" width="50" height="50" *ngIf="delivery?.shop === 'businesssales' ">
            <img class="service-img" src="assets/img/cakedesignlogo.png" width="50" height="50" *ngIf="delivery?.shop?.toLowerCase() === 'cakesales' ">
            <img class="service-img" src="assets/img/deluxyflowerslogo.png" width="50" height="50" *ngIf="delivery?.shop?.toLowerCase() === 'flowerssales'">
            <img class="service-img" src="assets/img/deluxy_nuovo_logo_2-157w.webp" width="50" height="50" *ngIf="delivery?.shop?.toLowerCase() === 'shopifysale'">
          </span> -->
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            <!--
            {{
              delivery?.shop?.toLowerCase() === 'businesssales' ? "B"+delivery?.orderId :
              delivery?.shop?.toLowerCase() === 'shopifysale' ? "D"+delivery?.orderId :
              delivery?.shop?.toLowerCase() === 'flowerssales' ? "F"+delivery?.orderId :
              delivery?.shop?.toLowerCase() === 'cakesales' ? "C"+delivery?.orderId : "---"
            }}
            -->
            <!-- {{ 
              (
                delivery?.orderId && delivery?.externalOrderSource
              ) ? 'M' + delivery.orderId
                : (
                  delivery?.orderId && !delivery?.externalOrderSource
                ) ? (delivery.orderId | saleName: delivery.shop)
                  : (
                    delivery?.ddtNumber && !delivery?.orderId && !delivery?.externalOrderSource
                  ) ? delivery.ddtNumber
                    : '---'
            }} -->
            {{
              delivery.correspondDelivery
                ? delivery.correspondDelivery
                : (delivery?.orderId && delivery?.externalOrderSource)
                  ? 'M' + delivery.orderId
                  : (delivery?.ddtNumber && !delivery?.externalOrderSource)
                    ? ((delivery.ddtNumber | saleName: delivery.shop) || delivery.ddtNumber)
                    : '---'
            }}
          </a>

          <!-- <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.orderId && delivery?.externalOrderSource">
            {{ 'M' + delivery.orderId }}  
          </a>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="!delivery?.externalOrderSource">
            {{ showSaleWithPlatform(delivery) }}
          </a> -->
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <span class="data-row-left">
          <h4 class="title table-title">PLATFORM:</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            <!-- {{ saleFilterValue ? saleFilterValue.toUpperCase() : '---' }} -->
            {{ delivery?.shopifySale ? delivery?.shopifySale?.platform?.toUpperCase() : "N/A" }}
          </a>
        </span>
      </div>

      <div class="item data-col-{{getSpacing('id')}}">
        <!--
        <h4 class="title" (click)="navigateOrder('Delivery.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.id')"></i>
          ID
        </h4>-->

      <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
        <h4 class="title table-title">ID :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{delivery.id}}
          </a></span>
      </div>

      <!-- <div class="item data-col-{{getSpacing('id')}}">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">ORIGINAL CONSEGNA :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{ delivery?.parentDelivery?.id || 'N/A' }}
          </a>
        </span>
      </div> -->

      <div class="parent-delivery-id" [ngClass]="{ 'hide-on-phone': !delivery?.parentDelivery?.id }">
        <span class="data-row-left">
          <h4 class="title table-title">ORIGINAL CONSEGNA :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{ delivery?.parentDelivery?.id || 'N/A' }}
          </a>
        </span>
      </div>


      <div class="item data-col-{{getSpacing('deliveryDate')}}">
        <!--
        <h4 class="title" (click)="navigateOrder('Delivery.deliveryDate')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Delivery.deliveryDate')"></i>
          DATA
        </h4>-->
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title dataGesture">DATA :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{delivery.deliveryDate | date:'dd/MM/yyyy'}}
          </a></span>
      </div>

      <div class="item center data-col-{{getSpacing('time')}}">
        <!--
        <h4 class="title" (click)="navigateOrder(['Delivery.fromTime', 'Delivery.toTime'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.fromTime', 'Delivery.toTime'])"></i>
          FASCIA ORARIA2
        </h4>-->
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">ORARIO :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() != 'hourlyrate' " >

            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
             <!-- {{delivery.fromTime}} - {{delivery.toTime}} -->
             <!--
            {{(delivery.fromTime | time:"hh:mm")}} -  {{(delivery.toTime | time:"hh:mm")}} -->
            <!-- {{delivery.deliveryDate | date:'dd/MM/yyyy'}} -->
            <!-- {{delivery.fromTime ? (delivery.fromTime | time:"HH:mm") : '-'}}-{{delivery.toTime ? (delivery.toTime | time:"HH:mm") : '-'}} -->
          </a>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="delivery?.service && showServiceDetails(delivery)?.service?.pricingModel?.toLowerCase() === 'hourlyrate' " >
            {{formatTimeShow(delivery.startTime, delivery.endTime)}}
          </a>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)" *ngIf="!delivery?.service" >
            {{formatTimeShow(delivery.fromTime, delivery.toTime)}}
          </a>
        </span>
      </div>

      <div class="item data-col-{{getSpacing('partner')}}" *ngIf="groupWhitelisted(['admin', 'expert', 'operation', 'teamleader'])">
        <!--
        <h4 class="title" (click)="navigateOrder('Partner.businessName')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
          PARTNER
        </h4>-->
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">PARTNER :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{delivery.partner?.businessName}}
          </a></span>
      </div>

      <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <!--
        <h4 class="title" (click)="navigateOrder(['UserExpert.surname', 'UserExpert.name'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['UserExpert.surname', 'UserExpert.name'])"></i>
          EXPERT
        </h4>-->
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">VALET :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{delivery.expert?.user?.surname}} {{delivery.expert?.user?.name}}
          </a></span>
      </div>

      <!--
      <div class="item data-col-{{getSpacing('expert')}}" *ngIf="groupWhitelisted(['admin', 'operation', 'partner'])">
        <span class="data-row-left">
          <h4 class="title table-title">CUSTOMER :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{
              delivery.customer ? delivery.customer?.user?.surname + " " + delivery.customer?.user?.name : "---"
            }}
          </a>
        </span>
      </div>
      -->

      <div class="item data-col-{{getSpacing('address')}}">
        <!--
        <h4 class="title" (click)="navigateOrder(['Delivery.city', 'Delivery.address'])">
          <i class="sort-icon fas" [ngClass]="orderIcon(['Delivery.city', 'Delivery.address'])"></i>
          INDIRIZZO
        </h4>-->
        <!-- consegna -->
        <span class="data-row-left tick" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">INDIRIZZO :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{((delivery.address ? delivery.address : "") + (delivery.city ? ", " + delivery.city : "")) || "---"}}
          </a></span>
      </div>

      <div class="item data-col-{{getSpacing('address')}}" *ngIf="groupWhitelisted('expert')">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">INDIRIZZO DI RITIRO :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{delivery?.pickUpAddress || "---"}}
          </a></span>
      </div>

      <div class="item data-col-{{getSpacing('address')}} pickUpTime">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">ORA RITIRO :</h4>
          <a  [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{ delivery?.pickUpTime || "---"}}
          </a></span>
      </div>

      <!-- <div class="item data-col-{{getSpacing('address')}} approvedTimings" *ngIf="selected == 'inactive'">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title table-title">ORA RITIRO :</h4>
          <a  [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            {{ delivery?.approvedTimings || "---"}}
          </a></span>
      </div> -->

      <div class="item left-space data-col-5">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title">TIPO SERVIZIO:</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
            <!--
            {{ delivery?.serviceType &&
              (delivery.serviceType.toLowerCase() === "fixedprice" ? "Servizi a Prezzo Fisso" :
              (delivery.serviceType.toLowerCase() === "hourlyrate" ? "Servizi a Ora" :
              (delivery.serviceType.toLowerCase() === "sales" ? "Servizi Vendita" : "")))
            }}
            -->
            {{ delivery?.serviceType | serviceName }}
          </a>
        </span>
      </div>

      <div class="item center left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title">DA FATTURARE :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
           {{
            delivery?.billable ? "Yes" : "No"
           }}
          </a>
        </span>
      </div>

      <div class="item center left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title">DA PAGARE :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
           {{
            delivery?.payable ? "Yes" : "No"
           }}
          </a>
        </span>
      </div>

      <!--
      <div class="item center left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title">REGOLA DI CONSEGNA TOTALE :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
           {{
            delivery?.withTotalDeliveryRule ? "Yes" : "No"
           }}
          </a>
        </span>
      </div>

      <div class="item center left-space data-col-30" *ngIf="groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader) ">
        <span class="data-row-left" [ngClass]="{'data-id': ((groupWhitelisted(['admin', 'expert']) && delivery?.expert && delivery?.expert?.isTeamLeader))}">
          <h4 class="title">REGOLA DI CONSEGNA GIORNALIERA :</h4>
          <a [routerLink]="getDeliveryLink(delivery.id, delivery.deluxyDelivery)">
           {{
            delivery?.withDailyDeliveryRule ? "Yes" : "No"
           }}
          </a>
        </span>
      </div>
      -->

       <!-- <style>
        .btn.vertical {
          /*
          display: flex;
          align-items: stretch;*/
          align-items: baseline;
          flex-direction: column;

        }
        </style>  -->

        <!--<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />


        <div >
          <button class="btn vertical">
          <i class="btnIcon fa fa-home"></i>
           <span>HOMEE</span>
        </button>
        </div>  -->
         <!-- <br/><br/><br/> -->
        <div class="item nowrap">
          <span class="data-row-left btn-container" *ngIf="routepage === 'activedeliveries'">
            
            <button 
              class="btn vertical align-items-center" 
              (click)="unlockPickUp(delivery)" 
              [disabled]="btnDisabled"
              *ngIf="(selected == 'active' && groupWhitelisted(['partner']) && delivery.expertIdentityCheck && !delivery.expertVerified)"
              >
              <i class="ml-10 fas fa-lock"></i>&nbsp;
              Sblocca il ritiro
            </button>

            <button 
              class="btn vertical align-items-center" 
              (click)="completePickUp(delivery)" 
              [disabled]="btnDisabled"
              *ngIf="(selected == 'active' && groupWhitelisted(['expert']) && delivery.expertIdentityCheck && delivery.expertVerified && !delivery.pickUpCompleted)"
              >
              <i class="ml-10 fas fa-check"></i>&nbsp;
              Ritiro completo
            </button>

            <button 
              class="btn vertical align-items-center" 
              (click)="delivered(delivery.id)" 
              [disabled]="btnDisabled"
              *ngIf="selected == 'active' && groupWhitelisted(['expert', 'teamleader']) && delivery.status == deliveryStatus.delivering"
              >
              <i class="ml-10 fas fa-check"></i>&nbsp;
              CONSEGNATO
            </button>

            <button 
              class="btn vertical align-items-center" 
              (click)="notDelivered(delivery)" 
              [disabled]="btnDisabled"
              *ngIf="selected == 'active' && groupWhitelisted(['expert', 'teamleader']) && delivery.status == deliveryStatus.delivering"
              >
              <i class="ml-10 fas fa-times"></i>&nbsp;
              NON CONSEGNATO
            </button>

            <button 
              class="btn vertical has-margin-bottom align-items-center" 
              (click)="delivering(delivery.id)" 
              [disabled]="btnDisabled"
              *ngIf="
                (selected == 'active' && groupWhitelisted(['expert']) && 
                  (delivery.status == deliveryStatus.assigned || delivery.status == deliveryStatus.accepted)) &&
                (delivery.expertIdentityCheck ? (delivery.expertVerified && delivery.pickUpCompleted) : true)
              ">
              <i class="ml-10 fas fa-truck"></i>&nbsp;
              IN CONSEGNA
            </button>

            <button 
              class="btn vertical has-margin-bottom align-items-center" 
              (click)="addReceipt(delivery)" 
              [disabled]="btnDisabled"
              *ngIf="selected == 'inactive' && groupWhitelisted('expert') && inActiveStatus.includes(delivery.status) && (delivery?.receipt === null)"
              >
              <i class="ml-10 fas fa-receipt"></i>&nbsp;
              ADD RECEIPT
            </button>

            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/consegne', delivery.id]" 
              *ngIf="groupWhitelisted(['admin', 'operation', 'expert', 'teamleader'])"
              >DETTAGLI
            </a>

            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/consegne', delivery.id]" 
              *ngIf="groupWhitelisted('partner') && ((delivery?.createdFrom === null) || (delivery?.createdFrom?.toLowerCase() != 'saleautomation') || (delivery?.acceptSale === 1))"
              >DETTAGLI
            </a>

            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/vendita/detail', delivery.id]" 
              *ngIf="groupWhitelisted('partner') && delivery?.createdFrom?.toLowerCase() === 'saleautomation' && delivery?.acceptSale === null"
              >DETTAGLI
            </a>

            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="acceptSaleForUniqueProduct(delivery)" 
              *ngIf="delivery?.createdFrom?.toLowerCase() === 'saleautomation' && delivery?.acceptSale === null && groupWhitelisted('partner')" 
              [disabled]="saleBtn || btnDisabled"
              >ACCETTA
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="accepting(delivery.id)" 
              *ngIf="groupWhitelisted('partner') && delivery?.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned) && delivery?.createdFrom === null" 
              [disabled]="btnDisabled"
              >ACCETTA
            </button>
            
            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="refuseSaleForUniqueProduct(delivery?.id)" 
              *ngIf="delivery?.createdFrom?.toLowerCase() === 'saleautomation' && delivery?.acceptSale === null && groupWhitelisted('partner')" 
              [disabled]="saleBtn || btnDisabled"
              >RIFIUTA
            </button>
            
            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/consegne', delivery.id, 'edit']" 
              *ngIf="groupWhitelisted(['admin', 'operation'])"
              >MODIFICA
            </a>
            
            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="deliveryCancellationRequest(delivery.id)" 
              *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'assigned')" 
              [disabled]="deliveryCancellationBtn"
              >RICHIEDI ANNULLAMENTO
            </button>
           
            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/consegne', delivery.id, 'edit']" 
              *ngIf="groupWhitelisted('partner') && (!delivery.deluxyDelivery) && (delivery.status == 'created' || delivery.status == 'delivered' || delivery.status == 'notDelivered')"
              >MODIFICA
            </a>
            
            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="expertModal(delivery)" 
              *ngIf="(groupWhitelisted(['admin', 'operation', 'teamleader']) || (groups.includes('expert') && loggedInExpert?.isTeamLeader)) && (selected == 'active') "
              >ASSEGNA
            </button>
            <!-- <button class="btn hvr-grow has-margin-right" (click)="approveTimings(delivery)" *ngIf="(groups.includes('partner') && (selected == 'inactive') && (delivery.status === 'delivered') && (delivery.service == 22) && (delivery.approvedTimingStatus === 0))">APPROVE TIMINGS</button> -->
            
            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="approveService22Timings(delivery)" 
              *ngIf="(groups.includes('expert') && (selected == 'inactive') && (delivery.status === 'deliveredWithTimeNotApproved' || delivery.status === 'deliveredWithTimeToBeApproved') && (delivery.service == 22) && (delivery.approvedTimingStatus === null || delivery?.approvedTimingStatus === 3))"
              >CHANGE TIME
            </button>
            
            <button 
              class="btn hvr-grow has-margin-right" 
              (click)="reviewService22Timings(delivery)" 
              *ngIf="(groups.includes('partner') && (selected == 'inactive') && (delivery.status === 'deliveredWithTimeNotApproved' || delivery.status === 'deliveredWithTimeToBeApproved') && (delivery.service == 22) && (delivery.approvedTimingStatus === 3)) || ((groups.includes('admin') || groups.includes('operation')) && (selected == 'inactive') && (delivery.status === 'deliveredWithTimeNotApproved' || delivery.status === 'deliveredWithTimeToBeApproved') && (delivery.service == 22) && (delivery.approvedTimingStatus === 0))"
              >REVIEW TIMINGS
            </button>
            
            <button 
              (click)="openInNewTab(delivery.id)"
              class="btn hvr-grow has-margin-right" 
              *ngIf="groupWhitelisted(['admin', 'operation', 'partner'])"
            >
            Monitorare
            </button>

            <button 
              (click)="handleModalBox(delivery.id)"
              class="btn hvr-grow has-margin-right" 
              *ngIf="groupWhitelisted(['admin', 'operation'])"
            >
            Additional Valet +/-
            </button>
          </span>

          <span class="data-row-left btn-container" *ngIf="routepage === 'notdelivered' && selected == 'active' && groupWhitelisted(['admin', 'operation', 'partner'])">

            <a 
              target="_blank" 
              class="btn hvr-grow has-margin-right" 
              [routerLink]="['/consegne', delivery.id]"
              *ngIf="(groupWhitelisted(['admin', 'operation', 'expert']) || 
                      (groupWhitelisted('partner') && 
                      ((delivery?.createdFrom === null) || 
                        (delivery?.createdFrom?.toLowerCase() !== 'saleautomation') || 
                        (delivery?.acceptSale === 1)))) || 
                    (groupWhitelisted('partner') && 
                      delivery?.createdFrom?.toLowerCase() === 'saleautomation' && 
                      delivery?.acceptSale === null)"
            >
              DETTAGLI
            </a>       

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="!delivery?.parentDelivery || !delivery.notDeliveredActionTaken"
              [routerLink]="['/consegne/duplica', delivery.id]" [queryParams]="{ notdelivered: true }"
              [disabled]="btnDisabled"
              >NUOVA CONSEGNA
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="!delivery?.parentDelivery || !delivery.notDeliveredActionTaken"
              (click)="cancelNotDeliveredDelivery(delivery)" 
              [disabled]="btnDisabled"
              >ANNULLA
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="groups.includes('expert')"
              [disabled]="btnDisabled"
              >ROTORNO IN BOUTIQUE
            </button>

            <button 
              class="btn hvr-grow has-margin-right" 
              *ngIf="groups.includes('expert')"
              [disabled]="btnDisabled"
              >PRODOTTO IN MACCHINA
            </button>

          </span>
        </div>
      <!-- <br/><br/><br/> -->
<!--
   <div class="item nowrap">

        <span  class="left">
          <button class="btn-footer btn-white has-margin-right" (click)="delivered(delivery.id)"
            *ngIf="selected == 'active' && groupWhitelisted('expert') && delivery.status == deliveryStatus.delivering">
            <i class="ml-10 fas fa-check"></i>CONSEGNATO
          </button>
      </span>
      <span  class="left">
          <button class="btn-footer btn-white has-margin-right" (click)="notDelivered(delivery.id)"
            *ngIf="selected == 'active' && groupWhitelisted('expert') && delivery.status == deliveryStatus.delivering">
            <i class="ml-10 fas fa-times"></i>NON

          </button>
      </span>
      <span  class="left">
          <button class="btn-footer btn-white has-margin-right" (click)="delivering(delivery.id)"
            *ngIf="selected == 'active' && groupWhitelisted('expert') && (delivery.status == deliveryStatus.assigned || delivery.status == deliveryStatus.accepted)">
            <i class="ml-10 fas fa-truck"></i>IN CONSEGNA
          </button>
      </span> -->
      <!-- <span  class="left">
        <button class="btn-footer btn-white has-margin-right" [routerLink]="['/consegne', delivery.id]"><i class="fa fa-list"></i> DETTAGLI</button>
      </span>
      <span  class="left">
        <button class="btn-footer btn-white has-margin-right" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('admin')"><i class="fa fa-pen"></i> MODIFICA</button>
      </span>
      <span  class="left">
        <button class="btn-footer btn-white has-margin-right" (click)="expertModal(delivery)" *ngIf="groupWhitelisted('admin')"><i class="fa fa-user"></i>ASSEGNA</button>
      </span>         -->


        <!-- <span class="left">
            <button class="btn btn-white has-margin-right" (click)="print($event)">
              <i class="ml-10 fas fa-file"></i>Stampa
            </button>
        </span>
        <span class="left">
        <button class="btn btn-white has-margin-right" (click)="directions($event)">
          <i class="ml-10 fas fa-directions"></i>Maps
        </button>
        </span>
        <span class="left">
        <button class="btn btn-white has-margin-right" (click)="showLink($event)">
          <i class="ml-10 fas fa-link"></i>Link
        </button>
      </span> -->
      <!-- <span class="left">
          <button class="btn btn-white has-margin-right" (click)="accepting(delivery.id)"
          *ngIf="groupWhitelisted('partner') && delivery.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned)">
            Accetta<i class="ml-10 fas fa fa-check"></i>
          </button>
        </span>
        <span class="left">
        <button class="btn btn-white has-margin-right" (click)="refusing(delivery.id)"
        *ngIf="groupWhitelisted('partner') && delivery.deluxyDelivery && (delivery.status == deliveryStatus.created || delivery.status == deliveryStatus.assigned)">
          Rifiuta  <i class="ml-10 fas fa-times-circle"></i>
        </button>
        </span>

      </div>  -->

          <!-- <div class="item nowrap">
             <span  class="left">
                <button class="btn-footer btn-white has-margin-right center" (click)="delivered(delivery.id)"
                  *ngIf="selected == 'active' && groupWhitelisted('expert') && delivery.status == deliveryStatus.delivering">
                  <i class="ml-10 fas fa-check"></i>CONSEGNATO
                </button>
            </span>
            <span  class="left">
                <button class="btn-footer btn-white has-margin-right center" (click)="notDelivered(delivery.id)"
                  *ngIf="selected == 'active' && groupWhitelisted('expert') && delivery.status == deliveryStatus.delivering">
                  <i class="ml-10 fas fa-times"></i>NON

                </button>
            </span>
            <span  class="left">
                <button class="btn-footer btn-white has-margin-right center" (click)="delivering(delivery.id)"
                  *ngIf="selected == 'active' && groupWhitelisted('expert') && (delivery.status == deliveryStatus.assigned || delivery.status == deliveryStatus.accepted)">
                  <i class="ml-10 fas fa-truck"></i>IN CONSEGNA
                </button>
            </span>
            <span  class="left">
              <button class="btn-footer btn-white has-margin-right" [routerLink]="['/consegne', delivery.id]"><i class="fa fa-list"></i> DETTAGLI</button>
            </span>
            <span  class="left">
              <button class="btn-footer btn-white has-margin-right" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('admin')"><i class="fa fa-pen"></i> MODIFICA</button>
            </span>
            <span  class="left">
              <button class="btn-footer btn-white has-margin-right" (click)="expertModal(delivery)" *ngIf="groupWhitelisted('admin')"><i class="fa fa-user"></i>ASSEGNA</button>
            </span>
        </div>  -->
      <!-- <br/><br/><br/>    -->




<!--
    <div style="width: auto;" >
        <button class="btn-footer" [routerLink]="['/consegne', delivery.id]"><i class="fa fa-list"></i> Dettagli</button>
        <button class="btn-footer" [routerLink]="['/consegne', delivery.id, 'edit']" *ngIf="groupWhitelisted('admin')"><i class="fa fa-pen"></i> Modifica</button>
        <button class="btn-footer" (click)="expertModal(delivery)"><i class="fa fa-user"></i> Assegna</button>

    </div> -->

    </div>
  </div>
  <!--/Custom built table-->

</section>
<!-- <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination> -->
<!-- Old Layout -->


<div *ngIf="showAddionalPriceValetModal" class="amp-backdrop">
  <div class="amp-box">

    <div class="amp-header">
      <h3 class="amp-title">Inserisci valore</h3>
    </div>

    <div class="amp-body">
      <label class="amp-label">Valore aggiuntivo valet (+ / -)</label>

      <input
        type="number"
        [(ngModel)]="additionalValetPlusMinus"
        class="amp-input"
        placeholder="Inserisci numero"
        [disabled]="isSubmitting"
      />
    </div>

    <div class="amp-footer">
      <button
        class="amp-btn"
        (click)="submitAdditionalValetPlusMinus()"
        [disabled]="isSubmitting"
      >
        <ng-container *ngIf="!isSubmitting">
          Aggiungi
        </ng-container>

        <ng-container *ngIf="isSubmitting">
          <span class="amp-spinner"></span>
          Caricamento...
        </ng-container>
      </button>

      <button
        class="amp-btn amp-btn--secondary"
        (click)="handleModalBox()"
      >
        Chiudi
      </button>
    </div>

  </div>
</div>

<div *ngIf="showAddressModal && selectedPartner" class="amp-backdrop">
    <div class="amp-box">

        <div class="amp-header">
            <div class="amp-badge">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                Indirizzi Multipli
            </div>
            <h3 class="amp-title"><span class="amp-partner-name">{{ selectedPartner.businessName }}</span> ha piÃ¹ indirizzi salvati</h3>
            <p class="amp-subtitle">Seleziona un indirizzo di ritiro per proseguire con questo ordine.</p>
        </div>

        <div class="amp-divider"></div>

        <div class="amp-default-block">
            <div class="amp-default-header">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Indirizzo Predefinito</span>
                <span class="amp-default-tag">Predefinito</span>
            </div>
            <p class="amp-default-address">{{ selectedPartner.address }}</p>
        </div>

        <div class="amp-section-label">Seleziona un indirizzo alternativo</div>

        <div class="amp-list">
            <label
                *ngFor="let addr of partnerPickupAddresses"
                class="amp-item"
                [class.amp-item--selected]="selectedPickupAddress === addr"
                [class.amp-item--disabled]="isConfirming">
                <input
                    type="radio"
                    [value]="addr"
                    [(ngModel)]="selectedPickupAddress"
                    [disabled]="isConfirming">
                <div class="amp-radio-dot">
                    <div class="amp-radio-inner"></div>
                </div>
                <div class="amp-address-text">
                    <span class="amp-address-label">{{ addr }}</span>
                </div>
                <svg class="amp-pin-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
                </svg>
            </label>
        </div>

        <div class="amp-footer">
            <button type="button" class="amp-btn amp-btn--cancel" (click)="handleAddressModal()" [disabled]="isConfirming">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                Annulla
            </button>
            <button type="button" class="amp-btn amp-btn--confirm" (click)="confirmPickupAddress()" [disabled]="isConfirming || !selectedPickupAddress">

                <span *ngIf="isConfirming" class="amp-spinner"></span>

                <ng-container *ngIf="!isConfirming">
                    Conferma Indirizzo
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </ng-container>

                <ng-container *ngIf="isConfirming">
                    Caricamento...
                </ng-container>
            </button>
        </div>
    </div>
</div>